import React from 'react';

import {ConnectedMoleculePhysicochemicalProperties} from 'chemistry/molecules/tabs/MoleculePhysicochemicalProperties';

export default function MoleculePhysicochemicalPropertiesTab({
  moleculeId,
}: {
  moleculeId: string;
}): JSX.Element {
  return (
    <div className="react-tab-container">
      <ConnectedMoleculePhysicochemicalProperties moleculeId={moleculeId} />
    </div>
  );
}
